const setBrandingVars = (branding) => {
    const myVariables = {};
    const { dbk } = window;

    Object.keys(branding.palette).forEach((key) => {
        if (typeof branding.palette[key] === 'object') {
            Object.keys(branding.palette[key]).forEach((value) => {
                myVariables[`--${key}-${value}`] = branding.palette[key][value];
            });
        } else {
            myVariables[`--${key}`] = branding.palette[key];
        }
    });

    Object.keys(branding.typography).forEach((key) => {
        if (typeof branding.typography[key] === 'object') {
            Object.keys(branding.typography[key]).forEach((value) => {
                if (
                    value === 'fontSize' &&
                    typeof branding.typography[key][value] === 'number'
                ) {
                    myVariables[
                        `--${key}-${value}`
                    ] = `${branding.typography[key][value]}px`;
                } else {
                    myVariables[`--${key}-${value}`] =
                        branding.typography[key][value];
                }
            });
        } else {
            myVariables[`--${key}`] = branding.typography[key];
        }
    });

    if (branding.components?.MuiButton?.defaultProps?.color) {
        const buttonColor = branding.components.MuiButton.defaultProps.color;

        Object.keys(branding.palette[buttonColor]).forEach((value) => {
            myVariables[`--buttonPrimary-${value}`] =
                branding.palette[buttonColor][value];
        });
    }

    const setVariables = (vars) =>
        Object.entries(vars).forEach((v) =>
            document.documentElement.style.setProperty(v[0], v[1]),
        );
    window.legacyBrandingJsonData = myVariables; // legacyBrandingJsonData is for CSS global variables
    setVariables(myVariables);

    // Set Modern Branding to session and window objects
    sessionStorage.setItem('modernBrandingJSON', JSON.stringify(branding));

    if (dbk) {
        dbk.setModernBranding(branding);
    }
};

export { setBrandingVars };
